import { render, staticRenderFns } from "./extraShown.vue?vue&type=template&id=3bcae447&scoped=true"
import script from "./extraShown.vue?vue&type=script&lang=js"
export * from "./extraShown.vue?vue&type=script&lang=js"
import style0 from "./extraShown.vue?vue&type=style&index=0&id=3bcae447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcae447",
  null
  
)

export default component.exports